import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import { EColors } from 'app/constants/colors'

const Phrase = ({ text, yOffset = 30, i = 0 }) => (
  <Fragment>
    <text fill="#637080" x="50" y={yOffset} fontSize={isMobile ? '14px' : '20px'} fontFamily="Roboto">
      {text}
    </text>
    <g transform={`translate(10, ${yOffset - 20}) scale(${0.9})`}>
      <circle id={`loadingCheckCircleSVG-${i}`} fill="rgba(255,255,255,0)" cx="16" cy="16" r="16" />
      <polygon
        points="21.661,7.643 13.396,19.328 9.429,15.361 7.075,17.714 13.745,24.384 24.345,9.708 "
        fill={EColors.BLUE}
        id={`loadingCheckSVG-${i}`}
      />
      <path
        d="M16,0C7.163,0,0,7.163,0,16s7.163,16,16,16s16-7.163,16-16S24.837,0,16,0z M16,30C8.28,30,2,23.72,2,16C2,8.28,8.28,2,16,2 c7.72,0,14,6.28,14,14C30,23.72,23.72,30,16,30z"
        fill={EColors.BLUE}
      />
    </g>
  </Fragment>
)

export default Phrase
